import { Component, effect } from '@angular/core';
import { AssemblyImportService } from './assembly-import.service';
import { BinderAssembly } from 'src/app/models/binder-assembly.model';
import { MessageService } from 'primeng/api';
import { BinderAssembliesService } from 'src/app/services/app/binder-assemblies.service';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AssemblyCardComponent } from '../assemblies/components/assembly-card.component';
import { BinderDialogService } from '@/services/app/binder-dialog.service';
import { AssemblyFinderService } from '@/services/app/assembly-finder.service';
import { BinderService } from '@/services/api/binder.service';

@Component({
  selector: 'app-assembly-import',
  imports: [AssemblyCardComponent, ButtonModule, CommonModule],
  template: `
    <div>
    <p class="mt-0 mb-4 p-0 line-height-3">Would you like to import this Assembly?</p>
    <div *ngIf="assembly" class="flex mb-4">
        <app-assembly-card [assembly]="assembly" class="full-width"></app-assembly-card>
    </div>
    <div class="button-container">
        <button pButton pRipple icon="pi pi-check" label="Confirm Import" (click)="onAssemblySaved(assembly)"></button>
    </div>
</div>
    `,
  styles: `
    .full-width {
    width: 100%;
}
.button-container {
    display: flex;
    justify-content: flex-end;
}
    `
})
export class AssemblyImportComponent {
  assembly: Partial<BinderAssembly> = {};

  binderId: number = 0;

  constructor(
    private assemblyImportService: AssemblyImportService,
    private assemblyListService: BinderAssembliesService,
    private messageService: MessageService,
    private binderDialogService: BinderDialogService,
    private assemblyFinderService: AssemblyFinderService,
    private currentBinderService: BinderService
  ) {
    effect(() => {
      this.assembly = this.assemblyImportService.importedAssembly();
      if (this.currentBinderService.currentBinder()) {
        this.binderId = this.currentBinderService.currentBinder().BinderID;
      }
    });
  }

  ngOnInit() {
  }

  onAssemblySaved(assembly: Partial<BinderAssembly>) {
    console.log('assembly saved', assembly);
    const sameCategoryAssemblies = this.assemblyListService.binderAssemblies().filter(binderAssembly => binderAssembly.CategoryID === assembly.CategoryID);
    const maxPrintOrder = Math.max(...sameCategoryAssemblies.map(a => a.PrintOrder), 0);
    const newData = {
      Name: assembly.Name,
      Categories: {
        connect: {
          CategoryID: assembly.CategoryID
        }
      },
      Description: assembly.Description,
      Price: assembly.Price,
      Quantity: assembly.Quantity,
      Type: assembly.Type,
      Binders: {
        connect: {
          BinderID: this.binderId
        }
      },
      PrintOrder: maxPrintOrder + 1,
    }
    this.assemblyListService.addAssembly(newData).subscribe({
      next: (updated) => {
        console.log('assembly updated', updated);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Assembly added', life: 3000 });
        this.binderDialogService.closeDialog();
        this.assemblyFinderService.setAssembly(updated);
      },
      error: (error) => {
        console.error('Error updating assembly:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error adding assembly', life: 3000 });
      }
    });
  }
}
